import { Card, Row, Col } from "react-bootstrap";
import { useGetCardListQuery, useGetGiftCreditQuery } from "../../../features/card/cardApi";
import PaymentCardList from "./PaymentCardList";
import { useAppDispatch } from "../../../Hook";
import { openPaymentModal } from "../../../features/users/usersSlice";
import { useState } from "react";
import CreditPlanModal from "../components/CreditPlanModal";
import { useGetUserProfileQuery } from "../../../features/users/usersApi";
import { PaymentSetting, UserRole } from "../../../features/users/usersTypes";
import PrimarySmallButton from "../../../components/buttons/PrimarySmallButton";
import { IoAddCircleSharp, IoCardOutline } from "react-icons/io5";
import BdapCard from "./BdapCard";
import { isGuildMortgageEmail } from "../../../features/bdap/bdapOptions";

const PaymentCard = () => {
  const dispatch = useAppDispatch();
  const { data: cardList } = useGetCardListQuery({});
  const { data: giftCredit } = useGetGiftCreditQuery(undefined);
  const { data: profileData } = useGetUserProfileQuery(undefined);

  console.log("giftCredit", giftCredit);

  const [show, setShow] = useState(false);

  const isAdmin = profileData?.data?.role === UserRole.ADMIN;
  const canManageCards = isAdmin || profileData?.data?.organization.payment_setting !== PaymentSetting.SAME_PAYMENT_METHOD;
  const hasCards = (cardList?.data?.length ?? 0) > 0;
  const canSeeBdap = isGuildMortgageEmail(profileData?.data?.email);

  return (
    <Row>
      <Col>
        <Card style={{ border: "none", borderLeft: "1px solid rgba(25, 34, 46, 0.08)", borderRadius: "0", backgroundColor: "transparent" }}>
          <Card.Body style={{ padding: 0, backgroundColor: "transparent" }}>
            <div
              className="sticky-filter-bar"
              style={{
                position: "sticky",
                top: "50px",
                zIndex: 100,
                height: "50px",
                marginBottom: 0,
                display: "flex",
                gap: "20px",
                padding: "10px 20px",
                lineHeight: "24px",
                borderBottom: "1px solid #eef0f2",
              }}>

            </div>
            <Row className=" m-2 mt-3">
              {isAdmin && (
              <Col className="col-12">
                <Card>
                  <Card.Body >
                    <CreditPlanModal
                      defaultPlan={cardList?.data.find((data) => data?.is_default)}
                      setShow={setShow}
                      show={show}
                    />
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h4 className="mb-0" style={{ fontSize: "18px", fontWeight: 600, color: "#212529", marginBottom: "8px" }}>
                            Gift Credits
                          </h4>
                          <p className="mt-2 mb-0" style={{ fontSize: "14px", color: "#6c757d" }}>
                            You have{" "}
                            <span className="text-primary font-bold" style={{ fontWeight: 600, color: "#0d6efd" }}>
                              ${giftCredit?.data.remaining_credits || 0}
                            </span>{" "}
                            Gift Credits Remaining.
                          </p>
                        </div>
                        <PrimarySmallButton
                          onClick={() => setShow(true)}
                          icon={<IoAddCircleSharp />}
                        >
                          Add Gift Credits
                        </PrimarySmallButton>
                      </div>
                  </Card.Body>
                </Card>
              </Col>
              )}
              {canSeeBdap && (
              <Col className={`col-12 ${isAdmin ? "mt-3" : ""}`}>
                <BdapCard />
              </Col>
              )}
              {canManageCards ? (

                <Col className="mt-3">
                  <Card>
                    <Card.Body style={{ padding: 0, backgroundColor: "transparent" }}>
                      <div
                        className="sticky-filter-bar"
                        style={{
                          position: "sticky",
                          top: "60px",
                          zIndex: 100,
                          padding: "12px 12px",
                          marginBottom: 0,
                          backgroundColor: "#ffffff",
                          height: "52px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <h4 className="mb-0 mt-0" style={{ fontSize: "18px", fontWeight: 600, color: "#212529", marginRight: "12px" }}>
                            Payment Methods
                          </h4>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <PrimarySmallButton
                            onClick={() => dispatch(openPaymentModal())}
                            icon={<IoCardOutline />}
                          >
                            Add Card
                          </PrimarySmallButton>
                        </div>
                      </div>
                      <div >
                        {hasCards ? (
                          <div className="table-wrapper">
                            <PaymentCardList cardList={cardList?.data ?? []} />
                          </div>
                        ) : (
                          <div style={{ padding: "20px", background: "#ffffff", borderTop: "1px solid #e9ecef" }}>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <div style={{ fontSize: "14px", fontWeight: 500, color: "#212529", marginBottom: "8px" }}>
                                  You haven't added any payment cards yet.
                                </div>
                                <div style={{ fontSize: "13px", color: "#6c757d" }}>
                                  Add a card to your account — it will only be charged when a gift is redeemed.
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

              ) : (

                <Col>
                  <Card style={{ border: "none", boxShadow: "none", backgroundColor: "transparent" }}>
                    <Card.Body style={{ padding: 0, backgroundColor: "transparent" }}>
                      <div style={{ padding: "20px", background: "#ffffff", borderTop: "1px solid #e9ecef" }}>
                        <div className="settings-header">Payment Method</div>
                        <div className="mt-2" style={{ fontSize: "14px", color: "#6c757d" }}>
                          Your organization uses a single payment method for all gifts. To update the payment method, please contact your administrator.
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

              )}
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row >
  );
};

export default PaymentCard;
